define((require) => {
    "use strict";

    var ImprovedView = require("editor/zbone/ImprovedView"),
        RangeInput   = require("services/rangeInput/RangeInput"),
        template     = require("ui/experience/action/properties/PulseEffectPropertiesView.tpl");

    return ImprovedView.extend({

        template: template,

        regions: {
            pulseRangeRegion: ".pulse-range-region"
        },

        onRender: function() {
            this.pulseRangeRegion.show(new RangeInput({
                model: this.model,
                modelAttribute: "value",
                step: 1,
                minVal: 1,
                maxVal: 5,
                minLabel: "Delicate",
                maxLabel: "Loud"
            }));
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/action/properties/PulseEffectPropertiesView.js